var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('PageTitle',{attrs:{"text":"Calendário","title-class":"h5","show-border-bottom":true}}),_vm._v(" "),_c('Calendar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }